import { render, staticRenderFns } from "./DashboardProfileCard.vue?vue&type=template&id=033e8a2c&scoped=true"
import script from "./DashboardProfileCard.vue?vue&type=script&lang=ts"
export * from "./DashboardProfileCard.vue?vue&type=script&lang=ts"
import style0 from "./DashboardProfileCard.vue?vue&type=style&index=0&id=033e8a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e8a2c",
  null
  
)

export default component.exports